'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUIIcon = function AUIIcon(props) {
    var iconfontClass = void 0;
    var customStyle = void 0;
    var className = props.className;
    var icon = props.icon,
        size = props.size,
        style = props.style,
        useIconFont = props.useIconFont,
        customIcon = props.customIcon,
        onClick = props.onClick,
        onMouseEnter = props.onMouseEnter,
        onMouseLeave = props.onMouseLeave,
        children = props.children;


    if (icon) {
        iconfontClass = useIconFont ? 'aui-iconfont-' + icon : 'aui-icon-' + icon;
    }

    className = (0, _classnames2.default)('aui-icon', 'aui-icon-' + size, iconfontClass, className);

    customStyle = style || {};

    if (customIcon) {
        customStyle.backgroundImage = 'url(' + customIcon + ')';
    }

    return _react2.default.createElement(
        'span',
        {
            className: className,
            style: customStyle,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        },
        children
    );
};

AUIIcon.displayName = 'AUIIcon';
AUIIcon.defaultProps = {
    useIconFont: true,
    size: 'small'
};
AUIIcon.propTypes = {
    /**
     * Icon innerHtml text/code (could be a string or an element)
     */
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),

    /**
     * Icon specific style
     */
    style: _propTypes2.default.object,

    /**
     * Type of icon size
     */
    size: _propTypes2.default.oneOf(['small', 'medium', 'large']),

    /**
     * Icon kind
     */
    icon: _propTypes2.default.string,

    /**
     * Replacement for Icon `background-image`
     */
    customIcon: _propTypes2.default.string,

    /**
     * Custom ClassName
     */
    className: _propTypes2.default.string,

    /**
     * Flag to define we are using icon of iconfont
     */
    useIconFont: _propTypes2.default.bool,

    /**
     * A click event bound on the icon
     */
    onClick: _propTypes2.default.func,

    /**
     * A mouse entering event bound on the icon
     */
    onMouseEnter: _propTypes2.default.func,

    /**
     * A mouse leaving event bound on the icon
     */
    onMouseLeave: _propTypes2.default.func
};

exports.default = AUIIcon;
//# sourceMappingURL=AUIIcon.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIIcon.js
// module id = 72
// module chunks = 0